import React from 'react';
import { useAnalytics } from 'hooks/useAnalytics';

/**
 *
 */
function WithAnalytics(InteractiveElement) {
  return function WrappedComponent(props) {
    const {
      category,
      action,
      label,
      trackingProp,
      clickFn,
      keyFn,
      additionalPayload,
      onChange,
      onClick,
      onKeyPress,
      ...restOfProps
    } = props;

    const { handleItemClick, handleKeystroke } = useAnalytics(
      category,
      action,
      label,
      trackingProp,
      clickFn,
      keyFn,
      additionalPayload
    );

    const hasTrackingProp = typeof trackingProp !== 'undefined';

    return (
      <InteractiveElement
        onChange={onChange || hasTrackingProp ? onChange : handleItemClick}
        onClick={onClick || hasTrackingProp ? onClick : handleItemClick}
        onKeyPress={onKeyPress || hasTrackingProp ? onKeyPress : handleKeystroke}
        {...restOfProps}
      />
    );
  };
}

export default WithAnalytics;
